<main
  class="app-shell h-dvh overflow-hidden text-ink lg:py-4 lg:px-4"
  [style.--shell-sidebar-w]="sidebarCollapsed() ? '4rem' : '16rem'"
>
  <div
    class="app-shell__grid flex h-full w-full gap-0 lg:grid lg:gap-2"
    [style.grid-template-columns]="sidebarCollapsed() ? '4rem minmax(0, 1fr)' : '16rem minmax(0, 1fr)'"
  >
    @if (!mobileSidebarOpen()) {
      <button
        appUiIconButton
        variant="soft"
        size="md"
        class="app-shell__mobile-menu-trigger"
        type="button"
        aria-label="Abrir navegação principal"
        title="Abrir menu"
        [attr.aria-expanded]="false"
        (click)="openMobileSidebar()"
      >
        <ng-icon name="heroBars3" size="19" aria-hidden="true" />
      </button>
    }

    @if (mobileSidebarOpen()) {
      <button
        appUiBackdropButton
        class="app-shell__mobile-sidebar-backdrop"
        type="button"
        aria-label="Fechar navegação principal"
        (click)="closeMobileSidebar()"
      ></button>
    }

    <aside
      class="app-shell__sidebar flex h-full flex-col overflow-hidden rounded-none lg:rounded-xl"
      [class.app-shell__sidebar--mobile-open]="mobileSidebarOpen()"
      [class.w-16]="sidebarCollapsed()"
      [class.w-64]="!sidebarCollapsed()"
      [attr.aria-label]="sidebarCollapsed() ? 'Navegação principal recolhida' : 'Navegação principal'"
    >
      <div
        class="flex min-h-0 flex-1 flex-col"
        [class.items-center]="sidebarCollapsed()"
        [class.px-1]="sidebarCollapsed()"
        [class.pb-1]="sidebarCollapsed()"
        [class.pt-2]="sidebarCollapsed()"
        [class.px-2]="!sidebarCollapsed()"
        [class.pb-2]="!sidebarCollapsed()"
        [class.pt-3]="!sidebarCollapsed()"
      >
        <div
          class="flex w-full items-center gap-2"
          [class.justify-center]="sidebarCollapsed()"
          [class.justify-between]="!sidebarCollapsed()"
        >
          @if (sidebarCollapsed()) {
            <button
              appUiIconButton
              variant="ghost"
              size="sm"
              class="sidebar-collapsed-toggle grid size-9 shrink-0 place-items-center rounded-lg text-muted transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
              type="button"
              (click)="toggleSidebar()"
              [attr.aria-label]="sidebarToggleLabel()"
              [attr.title]="sidebarToggleLabel()"
              [attr.aria-expanded]="!sidebarCollapsed()"
            >
              <img
                [src]="markSrc()"
                width="32"
                height="32"
                alt=""
                class="sidebar-collapsed-toggle__mark size-7 object-contain"
              />
              <ng-icon
                class="sidebar-collapsed-toggle__icon"
                [name]="sidebarToggleIcon()"
                size="18"
                aria-hidden="true"
              />
            </button>
          } @else {
            <a
              class="flex min-w-0 items-center gap-2.5 rounded-lg px-1 py-1 text-ink focus-visible:outline-none"
              routerLink="/"
              aria-label="Ir para início"
              title="Automato"
            >
              <img [src]="logoSrc()" width="209" height="30" alt="Automato" class="h-auto w-40 max-w-full object-contain" />
            </a>

            <button
              appUiIconButton
              variant="ghost"
              size="sm"
              class="app-icon-button app-shell__desktop-sidebar-toggle grid size-9 shrink-0 place-items-center rounded-lg"
              type="button"
              (click)="toggleSidebar()"
              [attr.aria-label]="sidebarToggleLabel()"
              [attr.title]="sidebarToggleLabel()"
              [attr.aria-expanded]="!sidebarCollapsed()"
            >
              <ng-icon [name]="sidebarToggleIcon()" size="18" aria-hidden="true" />
            </button>
          }

          <button
            appUiIconButton
            variant="ghost"
            size="sm"
            class="app-icon-button app-shell__mobile-sidebar-close"
            type="button"
            aria-label="Fechar navegação principal"
            title="Fechar menu"
            (click)="closeMobileSidebar()"
          >
            <ng-icon name="heroXMark" size="19" aria-hidden="true" />
          </button>
        </div>

        <nav class="mt-5 min-h-0 w-full flex-1 space-y-1 overflow-y-auto pr-0.5 text-sm" aria-label="Principal">
          @for (group of navGroups(); track $index) {
            @if ($index > 0) {
              <div class="my-2 h-px bg-line/75"></div>
            }

            @for (item of group; track item.path) {
              @if (hasVisibleChildren(item)) {
                @if (sidebarCollapsed()) {
                  <button
                    appUiBackdropButton
                    class="app-nav-link flex min-h-10 w-full items-center justify-center gap-3 rounded-lg px-2 font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                    [class.app-nav-link--active]="isNavItemActive(item)"
                    type="button"
                    [ngpMenuTrigger]="collapsedNavMenu"
                    ngpMenuTriggerPlacement="right-start"
                    [attr.aria-label]="item.label"
                    [attr.title]="item.label"
                  >
                    <ng-icon [name]="item.icon" size="18" aria-hidden="true" class="shrink-0" />
                  </button>

                  <ng-template #collapsedNavMenu>
                    <div appMenuPanel class="collapsed-nav-menu" [attr.aria-label]="'Navegação de ' + item.label">
                      <div class="collapsed-nav-menu__header">
                        <span class="collapsed-nav-menu__iconbox">
                          <ng-icon [name]="item.icon" size="17" aria-hidden="true" />
                        </span>
                        <span class="min-w-0">
                          <span class="block truncate text-sm font-semibold text-ink">{{ item.label }}</span>
                          <span class="block truncate text-xs text-muted">{{ item.eyebrow }}</span>
                        </span>
                      </div>
                      <div appMenuSeparator></div>

                      @if (!hasMainRouteChild(item)) {
                        <a
                          appMenuItem
                          [routerLink]="item.path"
                          [attr.aria-current]="isNavItemDirectlyActive(item) ? 'page' : null"
                        >
                          <span class="flex min-w-0 items-center gap-2.5">
                            <ng-icon [name]="item.icon" size="16" aria-hidden="true" class="shrink-0 text-muted" />
                            <span class="truncate">Visão geral</span>
                          </span>
                        </a>
                      }

                      @if (item.children; as collapsedChildren) {
                        @for (child of collapsedChildren; track child.path) {
                          <a
                            appMenuItem
                            [routerLink]="child.path"
                            [attr.aria-current]="isNavItemDirectlyActive(child) ? 'page' : null"
                          >
                            <span class="flex min-w-0 items-center gap-2.5">
                              <ng-icon [name]="child.icon" size="16" aria-hidden="true" class="shrink-0 text-muted" />
                              <span class="truncate">{{ child.label }}</span>
                            </span>
                          </a>
                        }
                      }
                    </div>
                  </ng-template>
                } @else {
                  <div
                    class="app-nav-link app-nav-parent-row flex min-h-10 w-full items-center rounded-lg font-medium transition"
                    [class.app-nav-link--active]="isNavItemActive(item)"
                  >
                    <a
                      class="app-nav-parent-target flex min-h-10 min-w-0 flex-1 items-center gap-3 rounded-l-lg py-2 pl-3 pr-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                      [routerLink]="item.path"
                      (click)="openNavGroup(item)"
                    >
                      <ng-icon [name]="item.icon" size="18" aria-hidden="true" class="shrink-0" />
                      <span class="min-w-0 flex-1 truncate text-left">{{ item.label }}</span>
                    </a>
                    <button
                      appUiIconButton
                      variant="ghost"
                      size="sm"
                      class="app-nav-group-toggle grid size-9 shrink-0 place-items-center rounded-r-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                      type="button"
                      [attr.aria-expanded]="isNavGroupExpanded(item)"
                      [attr.aria-label]="isNavGroupExpanded(item) ? 'Recolher submenu de ' + item.label : 'Expandir submenu de ' + item.label"
                      (click)="toggleNavGroup(item)"
                    >
                      <ng-icon
                        name="heroChevronDown"
                        size="14"
                        aria-hidden="true"
                        class="app-nav-chevron shrink-0"
                        [class.app-nav-chevron--open]="isNavGroupExpanded(item)"
                      />
                    </button>
                  </div>

                  @if (isNavGroupExpanded(item)) {
                    @if (item.children; as children) {
                      <div class="app-nav-children" role="group" [attr.aria-label]="item.label">
                        @for (child of children; track child.path) {
                          <a
                            class="app-nav-child-link flex min-h-8 items-center rounded-md px-2 py-1.5 font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                            [class.app-nav-child-link--active]="isNavItemDirectlyActive(child)"
                            [routerLink]="child.path"
                          >
                            <span class="truncate">{{ child.label }}</span>
                          </a>
                        }
                      </div>
                    }
                  }
                }
              } @else {
                <a
                  class="app-nav-link flex min-h-10 items-center gap-3 rounded-lg font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                  [class.justify-center]="sidebarCollapsed()"
                  [class.px-2]="sidebarCollapsed()"
                  [class.px-3]="!sidebarCollapsed()"
                  [class.app-nav-link--active]="isNavItemActive(item)"
                  [routerLink]="item.path"
                  [attr.aria-label]="sidebarCollapsed() ? item.label : null"
                  [attr.title]="sidebarCollapsed() ? item.label : null"
                >
                  <ng-icon [name]="item.icon" size="18" aria-hidden="true" class="shrink-0" />
                  @if (!sidebarCollapsed()) {
                    <span class="truncate">{{ item.label }}</span>
                  }
                </a>
              }
            }
          }
        </nav>

        <div class="mt-3 w-full">
          @if (settingsNavItem(); as settingsItem) {
            @if (hasVisibleChildren(settingsItem)) {
              @if (sidebarCollapsed()) {
                <a
                  class="app-nav-link flex min-h-10 items-center justify-center gap-3 rounded-lg px-2 font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                  [class.app-nav-link--active]="isNavItemActive(settingsItem)"
                  [routerLink]="settingsItem.path"
                  [attr.aria-label]="settingsItem.label"
                  [attr.title]="settingsItem.label"
                >
                  <ng-icon [name]="settingsItem.icon" size="18" aria-hidden="true" class="shrink-0" />
                </a>
              } @else {
                <button
                  appUiBackdropButton
                  class="app-nav-link app-nav-group-toggle flex min-h-10 w-full items-center gap-3 rounded-lg px-3 font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                  [class.app-nav-link--active]="isNavItemActive(settingsItem)"
                  type="button"
                  [attr.aria-expanded]="isNavGroupExpanded(settingsItem)"
                  (click)="toggleNavGroup(settingsItem)"
                >
                  <ng-icon [name]="settingsItem.icon" size="18" aria-hidden="true" class="shrink-0" />
                  <span class="min-w-0 flex-1 truncate text-left">{{ settingsItem.label }}</span>
                  <ng-icon
                    name="heroChevronDown"
                    size="14"
                    aria-hidden="true"
                    class="app-nav-chevron shrink-0"
                    [class.app-nav-chevron--open]="isNavGroupExpanded(settingsItem)"
                  />
                </button>

                @if (isNavGroupExpanded(settingsItem)) {
                  @if (settingsItem.children; as settingsChildren) {
                    <div class="app-nav-children" role="group" [attr.aria-label]="settingsItem.label">
                      @for (child of settingsChildren; track child.path) {
                        <a
                          class="app-nav-child-link flex min-h-8 items-center rounded-md px-2 py-1.5 font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                          [class.app-nav-child-link--active]="isNavItemDirectlyActive(child)"
                          [routerLink]="child.path"
                        >
                          <span class="truncate">{{ child.label }}</span>
                        </a>
                      }
                    </div>
                  }
                }
              }
            } @else {
              <a
                class="app-nav-link flex min-h-10 items-center gap-3 rounded-lg font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                [class.justify-center]="sidebarCollapsed()"
                [class.px-2]="sidebarCollapsed()"
                [class.px-3]="!sidebarCollapsed()"
                [class.app-nav-link--active]="isNavItemActive(settingsItem)"
                [routerLink]="settingsItem.path"
                [attr.aria-label]="sidebarCollapsed() ? settingsItem.label : null"
                [attr.title]="sidebarCollapsed() ? settingsItem.label : null"
              >
                <ng-icon [name]="settingsItem.icon" size="18" aria-hidden="true" class="shrink-0" />
                @if (!sidebarCollapsed()) {
                  <span class="truncate">{{ settingsItem.label }}</span>
                }
              </a>
            }
          }

          <div class="mt-2 border-t border-line/80 pt-2">
            <button
              class="app-user-menu flex min-h-11 w-full items-center gap-2 rounded-lg text-left text-ink transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
              [class.justify-center]="sidebarCollapsed()"
              [class.px-2]="sidebarCollapsed()"
              [class.px-3]="!sidebarCollapsed()"
              type="button"
              [ngpMenuTrigger]="accountMenu"
              ngpMenuTriggerPlacement="top-start"
              [attr.aria-label]="sidebarCollapsed() ? 'Abrir menu do usuário' : null"
              [attr.title]="sidebarCollapsed() ? 'Abrir menu do usuário' : null"
            >
              @if (userAvatarUrl()) {
                <img [ngSrc]="userAvatarUrl()!" width="32" height="32" alt="" class="size-8 shrink-0 rounded-md object-cover" />
              } @else {
                <span class="grid size-8 shrink-0 place-items-center rounded-md bg-soft text-xs font-bold text-ink">
                  {{ userInitials() }}
                </span>
              }
              @if (!sidebarCollapsed()) {
                <span class="min-w-0 flex-1">
                  <span class="block truncate text-[0.68rem] font-semibold uppercase tracking-wide text-muted">{{ businessName() }}</span>
                  <span class="block truncate text-sm font-semibold">{{ userName() }}</span>
                </span>
                <ng-icon name="heroChevronDown" size="15" aria-hidden="true" class="shrink-0 text-muted" />
              }
            </button>
          </div>
        </div>
      </div>
    </aside>

    <section class="h-full min-h-0 min-w-0 flex-1">
      <div class="app-shell__panel surface-noise flex h-full min-h-0 flex-col overflow-hidden rounded-xl border border-line bg-panel shadow-panel">
        <div class="app-shell__panel-scroll min-h-0 min-w-0 flex-1 overflow-auto">
          <router-outlet />
        </div>
      </div>
    </section>
  </div>
</main>

@if (themePulse(); as pulse) {
  <div
    class="theme-transition-pulse"
    aria-hidden="true"
    [style.--theme-pulse-color]="pulse.color"
    [style.--theme-pulse-x.px]="pulse.x"
    [style.--theme-pulse-y.px]="pulse.y"
  ></div>
}

<ng-template #businessMenu>
  <div appMenuPanel>
    <p class="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Business atual</p>
    <p class="truncate px-3 pb-2 text-sm font-semibold text-ink">{{ businessName() }}</p>
    <div appMenuSeparator></div>
    @for (business of availableBusinesses(); track business.id) {
      <button
        appMenuItem
        type="button"
        [ngpMenuItemDisabled]="businessSwitcherDisabled(business)"
        (click)="switchBusiness(business)"
      >
        <span class="flex min-w-0 items-center gap-2">
          <ng-icon name="heroBuildingOffice2" size="16" aria-hidden="true" class="shrink-0 text-muted" />
          <span class="min-w-0">
            <span class="block truncate">{{ business.name }}</span>
            <span class="block truncate text-xs text-muted">{{ businessAccessLabel(business) }}</span>
          </span>
        </span>
        @if (business.id === currentBusinessId()) {
          <span class="text-xs font-semibold text-accent">Atual</span>
        }
      </button>
    } @empty {
      <button appMenuItem type="button" [ngpMenuItemDisabled]="true">
        <span class="flex items-center gap-2">
          <ng-icon name="heroBuildingOffice2" size="16" aria-hidden="true" class="text-muted" />
          Nenhum business disponível
        </span>
      </button>
    }
    <div appMenuSeparator></div>
    <button appMenuItem type="button" (click)="loadBusinesses()" [ngpMenuItemDisabled]="businessSwitcherLoading()">
      <span class="flex items-center gap-2">
        <ng-icon name="heroArrowPath" size="16" aria-hidden="true" class="text-muted" />
        Atualizar lista
      </span>
    </button>
  </div>
</ng-template>

@if (commandPaletteOpen()) {
  <div
    class="fixed inset-0 z-50 grid place-items-start bg-ink/30 p-4 pt-24 backdrop-blur-sm sm:place-items-center sm:pt-4"
    role="presentation"
  >
    <button
      appUiBackdropButton
      class="absolute inset-0 cursor-default"
      type="button"
      aria-label="Fechar comandos"
      (click)="closeCommandPalette()"
    ></button>
    <section
      class="command-palette glass-surface relative z-10 w-full max-w-2xl rounded-xl border border-line bg-panel p-0 text-ink shadow-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="command-palette-title"
      aria-describedby="command-palette-description"
    >
      <div class="border-b border-line p-4">
        <div class="flex items-center gap-3">
          <span class="grid size-9 shrink-0 place-items-center rounded-lg bg-accent-soft text-accent-strong">
            <ng-icon name="heroCommandLine" size="18" aria-hidden="true" />
          </span>
          <div class="min-w-0">
            <h2 id="command-palette-title" class="font-brand text-base font-bold leading-tight text-ink">Comandos</h2>
            <p id="command-palette-description" class="text-xs leading-5 text-muted">
              Abra módulos, configurações e áreas de trabalho.
            </p>
          </div>
        </div>

        <label class="relative mt-4 block">
          <span class="sr-only">Filtrar comandos</span>
          <ng-icon
            name="heroMagnifyingGlass"
            size="17"
            aria-hidden="true"
            class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted"
          />
          <input
            #commandInput
            appInput
            surface="transparent"
            leadingIcon
            type="search"
            placeholder="Digite módulo, fluxo ou área"
            autocomplete="off"
            [value]="commandQuery()"
            (input)="setCommandQuery($event)"
            (keydown)="handleCommandKeydown($event)"
          />
        </label>
      </div>

      <div class="max-h-[min(28rem,65vh)] overflow-y-auto p-2">
        @if (filteredCommandItems().length > 0) {
          <div class="space-y-1">
            @for (item of filteredCommandItems(); track item.path) {
              <button
                appUiBackdropButton
                class="flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left transition hover:bg-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
                type="button"
                (click)="selectCommand(item)"
              >
                <span class="grid size-9 shrink-0 place-items-center rounded-lg border border-line bg-panel text-accent-strong">
                  <ng-icon [name]="item.icon" size="18" aria-hidden="true" />
                </span>
                <span class="min-w-0 flex-1">
                  <span class="flex min-w-0 items-center gap-2">
                    <span class="truncate text-sm font-semibold text-ink">{{ item.label }}</span>
                    <span class="rounded-md bg-soft px-1.5 py-0.5 text-[0.66rem] font-semibold text-muted">
                      {{ item.status }}
                    </span>
                  </span>
                  <span class="mt-0.5 block truncate text-xs text-muted">{{ item.description }}</span>
                  @if (item.parentLabel) {
                    <span class="mt-0.5 block truncate text-[0.68rem] font-semibold uppercase tracking-wide text-muted/75">
                      {{ item.parentLabel }}
                    </span>
                  }
                </span>
                <span class="hidden items-center gap-1 rounded-md border border-line bg-soft px-1.5 py-0.5 text-[0.68rem] font-semibold text-muted sm:flex">
                  <ng-icon name="heroSlash" size="12" aria-hidden="true" />
                  {{ item.path.slice(1) }}
                </span>
              </button>
            }
          </div>
        } @else {
          <div class="px-4 py-10 text-center">
            <p class="text-sm font-semibold text-ink">Nenhum comando encontrado</p>
            <p class="mt-1 text-sm text-muted">Tente buscar por módulo, operação ou configuração.</p>
          </div>
        }
      </div>
    </section>
  </div>
}

<ng-template #accountMenu>
  <div appMenuPanel>
    <div class="account-menu__business-header">
      <span class="account-menu__business-iconbox" aria-hidden="true">
        <ng-icon name="heroBuildingOffice2" size="18" class="text-accent-strong" />
      </span>
      <div class="min-w-0">
        <p class="text-[0.68rem] font-semibold uppercase tracking-wide text-muted">Business</p>
        <p class="truncate text-sm font-semibold text-ink">{{ businessName() }}</p>
      </div>
    </div>
    <div class="px-1.5 py-1">
      <div class="rounded-md px-3 py-2">
        <div class="min-w-0">
          <p class="truncate text-sm font-semibold text-ink">{{ userName() }}</p>
          @if (userEmail()) {
            <p class="truncate text-xs text-muted">{{ userEmail() }}</p>
          }
        </div>
      </div>
    </div>
    <div appMenuSeparator></div>
    @if (availableBusinesses().length > 1) {
      <a appMenuItem routerLink="/configuracoes/perfil" type="button">
        <span class="flex items-center gap-2">
          <ng-icon name="heroBuildingOffice2" size="16" aria-hidden="true" class="text-muted" />
          Trocar business
        </span>
      </a>
    }
    <button appMenuItem type="button" [ngpMenuItemCloseOnSelect]="false" (click)="cycleTheme($event)">
      <span class="flex items-center gap-2">
        <span class="theme-cycle-icon" [attr.data-theme-mode]="themeMode()" aria-hidden="true">
          <span class="theme-cycle-icon__track">
            <ng-icon name="heroSun" size="16" class="theme-cycle-icon__item" />
            <ng-icon name="heroMoon" size="16" class="theme-cycle-icon__item" />
            <ng-icon name="heroComputerDesktop" size="16" class="theme-cycle-icon__item" />
          </span>
        </span>
        Trocar tema
      </span>
      <span class="text-xs font-semibold text-accent">{{ themeModeLabel(themeMode()) }}</span>
    </button>
    <a appMenuItem routerLink="/configuracoes/perfil" type="button">
      <span class="flex items-center gap-2">
        <ng-icon name="heroUser" size="16" aria-hidden="true" class="text-muted" />
        Perfil
      </span>
    </a>
    <button appMenuItem tone="danger" type="button" (click)="logout()">
      <span class="flex items-center gap-2">
        <ng-icon name="heroArrowRightOnRectangle" size="16" aria-hidden="true" />
        Sair
      </span>
    </button>
  </div>
</ng-template>
